export const DriverErrorsConst = {
    driverForm: {
        DRIV020: "El conductor ya existe"
    },
    default: "Ocurrió un error",
};